import React from "react";
import particlesmblicon from "../assets/images/particles-mbl.svg";

function BoPaymentWrapper(props) {
  return (
    <div className="col-md-5 col-lg-4 onbo-sidebar">
      <img className="particles-mbl" src={particlesmblicon} alt="prctice" />
      <div className="onbo-inn">
        <div className="bo-thumb">
          <a href="/" aria-label="BO Payments">
            {/* Text wordmark instead of logo.svg: that asset is a dark glyph
                drawn for a light background and is nearly invisible on the
                ink auth panel. */}
            <div className="bopay-nav-wordmark">
              <span className="bopay-nav-wordmark-bo">Bo </span>
              <span className="bopay-nav-wordmark-payments">Payments</span>
            </div>
            <span className="bopay-nav-env">Super Admin</span>
          </a>
        </div>
        <div className="bo-info mt-70">
          <h1>
            <h1>{props.pagename}</h1>
          </h1>
          <h4>{props.pagemsg}</h4>
        </div>
      </div>
    </div>
  );
}

export default BoPaymentWrapper;
